import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Backdrop from "@mui/material/Backdrop";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import AIFunctions from "./AIFunctions";
import Tools from "./JNSTools";

function AIQueryComponent(props) {
  let queryBoxRef;
  const [answer, setAnswer] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [fontsize, setFontsize] = useState(12);
  const [localWait, setLocalWait] = useState(false);
  const scrollRef = useRef();

  const EXPANDED_WIDTH = 700;
  const CONTRACTED_WIDTH = 300;
  const MINIMUM_FONT_SIZE = 8;
  const MAXIMUM_FONT_SIZE = 24;

  let queryData = "";
  if (props.queryDataType && props.queryData) {
    const delimiter = ":::" + props.queryDataType.toLowerCase() + ":::";

    queryData =
      delimiter +
      (typeof props.queryData == "string"
        ? props.queryData
        : JSON.stringify(props.queryData)) +
      delimiter;
  }

  const handleKeyUp = async (event) => {
    if (event.keyCode == 13 && event.shiftKey == false) {
      setLocalWait(true);
      let query = queryBoxRef.value;
      let dataToSend = "";
      if (query.substring(0, 6).toLowerCase() == "nodata:") {
        query = query.substring(7);
      } else {
        const projData =
          ":::project:::" +
          JSON.stringify(sessionStorage.getItem("projectObject")) +
          ":::project:::";
        dataToSend = queryData + projData;
      }
      queryBoxRef.value = "";
      const aiResponse = await Tools.queryChatGPT(query, dataToSend);
      //const aiResponse = "";

      const reverseResponse = aiResponse.reverse();

      const answerLines = [];
      if (reverseResponse.length > 0) {
        reverseResponse.forEach((msg) => {
          const lineArray = msg.content.split("\n");
          lineArray.forEach((line) => {
            if (line) {
              answerLines.push({ role: msg.role, content: line });
            }
          });
        });
      }
      setLocalWait(false);
      setAnswer(answerLines);
    }
  };

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const handleZoomIn = () => {
    if (fontsize < MAXIMUM_FONT_SIZE) {
      setFontsize(fontsize + 2);
    }
  };

  const handleZoomOut = () => {
    if (fontsize > MINIMUM_FONT_SIZE) {
      setFontsize(fontsize - 2);
    }
  };

  const handleDownload = () => {
    if (answer.length > 0) {
      let downloadableAnswer = "";

      answer.forEach((answerLine) => {
        downloadableAnswer +=
          answerLine.role.toUpperCase() +
          String.fromCharCode(13) +
          String.fromCharCode(10) +
          answerLine.content +
          String.fromCharCode(13) +
          String.fromCharCode(10);
      });

      let dataUrl = "data:text/plain," + downloadableAnswer;
      let a = document.createElement("a");
      a.href = dataUrl;
      a.download =
        "collabcenter_AIexport_" +
        new Date().toISOString().substring(0, 19) +
        ".txt";
      a.click();
    }
  };

  useEffect(() => {
    scrollRef.current.scrollIntoView({ behaviour: "smooth" });
  });

  return (
    <Box
      width={expanded ? EXPANDED_WIDTH : CONTRACTED_WIDTH}
      sx={{
        height: "600px",
        border: "solid 1px",
        backgroundColor: "dimgray",
        borderRadius: "10px",
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box>
          <IconButton onClick={handleExpand} sx={{ padding: "0px 20px" }}>
            {expanded ? (
              <EastIcon fontSize="medium" sx={{ color: "white" }} />
            ) : (
              <WestIcon fontSize="medium" sx={{ color: "white" }} />
            )}
          </IconButton>
        </Box>
        <Box>
          <IconButton onClick={handleZoomIn} sx={{ padding: "0px" }}>
            <ZoomInIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
          <IconButton onClick={handleZoomOut} sx={{ padding: "0px" }}>
            <ZoomOutIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
        </Box>
        <Box>
          <IconButton onClick={handleDownload} sx={{ padding: "0px 20px" }}>
            <FileDownloadIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Box>
      <Box
        width={expanded ? EXPANDED_WIDTH - 30 : CONTRACTED_WIDTH - 30}
        sx={{
          margin: "0px 15px 10px 15px",
          height: "480px",
          border: "solid 2px",
          borderColor: "white",
          borderRadius: "10px",
          backgroundColor: "black",
          overflowY: "auto",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={localWait}
        >
          <Stack sx={{ width: "100%", color: "grey.500" }} spacing={5}>
            <LinearProgress variant="query" color="secondary" />
            <LinearProgress color="success" />
            <LinearProgress variant="query" color="warning" />
            <LinearProgress color="primary" />
          </Stack>
        </Backdrop>
        {answer.map((msg, index) => (
          <Typography
            key={"msg" + index}
            fontSize={fontsize}
            sx={{
              color: msg.role == "user" ? "Aqua" : "white",
              padding: "5px",
            }}
          >
            {msg.content}
          </Typography>
        ))}
        <div ref={scrollRef}></div>
      </Box>
      <Box width={expanded ? EXPANDED_WIDTH - 30 : CONTRACTED_WIDTH - 30}>
        <textarea
          id="__aiQueryBox"
          ref={(messageArea) => (queryBoxRef = messageArea)}
          rows={4}
          //onChange={handleChange}
          onKeyUp={handleKeyUp}
          placeholder="Type your query here.  Prefix the question with 'nodata:' if the AI does not need to reference the current data set."
          style={{
            resize: "none",
            backgroundColor: "oldlace",
            width: "100%",
            display: "inline-block",
            verticalAlign: "middle",
            fontFamily: "sans-serif",
            fontSize: "small",
            margin: "0px 15px",
            cursor: "text",
          }}
        />
      </Box>
    </Box>
  );
}

export default AIQueryComponent;

AIQueryComponent.propTypes = {
  queryData: PropTypes.array,
  queryDataType: PropTypes.string,
};
